@if (formData.formGroup) {
  <div class="input-wrapper"
       [formGroup]="formData.formGroup">
    @if (isLoading) {
      <p-skeleton height="50px"
                  class="mb-2" />

      <label class="label skeletonLabel"
             for="{{ formData.id }}">
        @if (formData.iconLeft) {
          <span class="material-symbols-rounded icon-left">
              {{ formData.iconLeft }}
            </span>
        }

        {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
      </label>
    } @else {

      <p-floatlabel variant="on">
        <p-autocomplete
          [id]="formData.id"
          [formControlName]="formData.id"
          [dropdown]="true"
          [showClear]="formData.showClear"
          dropdownMode="blank"
          [suggestions]="filteredSuggestions"
          [placeholder]="formData.placeholder"
          [forceSelection]="false"
          appendTo="body"
          (completeMethod)="search($event)">
        </p-autocomplete>

        <label class="on_label"
               for="{{ formData.id }}">
          @if (formData.iconLeft) {
            <span class="material-symbols-rounded icon-left">
              {{ formData.iconLeft }}
            </span>
          }

          {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
        </label>
      </p-floatlabel>
    }
  </div>
}

@if (formData.infoText) {
  <p class="message info">
    {{ formData.isTranslated ? (formData.infoText | translateSafe) : formData.infoText }}
  </p>
}
